'use client';

import React from 'react';


interface FilterPanelProps {
  selectedTypes: string[];
  selectedRegions: string[];
  onTypeToggle: (type: string) => void;
  onRegionToggle: (region: string) => void;
  onClearFilters: () => void;
}

const FilterPanel: React.FC<FilterPanelProps> = ({
  selectedTypes,
  selectedRegions,
  onTypeToggle,
  onRegionToggle,
  onClearFilters,
}) => {
  const eventTypes = [
    { id: 'preparation', label: 'Preparation', color: 'bg-peaceful-teal' },
    { id: 'celebration', label: 'Celebration', color: 'bg-accent' },
    { id: 'community', label: 'Community', color: 'bg-secondary' },
    { id: 'global', label: 'Global Unity', color: 'bg-primary' },
  ];

  const regions = [
    'North America',
    'South America',
    'Europe',
    'Africa',
    'Asia',
    'Oceania',
    'Middle East',
  ];

  const hasActiveFilters = selectedTypes.length > 0 || selectedRegions.length > 0;

  return (
    <div className="bg-card rounded-lg shadow-sm p-6">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-headline font-bold text-foreground">Filters</h3>
        {hasActiveFilters && (
          <button
            onClick={onClearFilters}
            className="text-sm font-body text-primary hover:text-primary/80 transition-colors duration-200"
          >
            Clear All
          </button>
        )}
      </div>

      {/* Event Types */}
      <div className="mb-6">
        <h4 className="text-sm font-cta font-bold text-foreground mb-3">Event Type</h4>
        <div className="space-y-2">
          {eventTypes.map((type) => (
            <label
              key={type.id}
              className="flex items-center gap-3 cursor-pointer group"
            >
              <input
                type="checkbox"
                checked={selectedTypes.includes(type.id)}
                onChange={() => onTypeToggle(type.id)}
                className="w-4 h-4 rounded border-border text-primary focus:ring-primary focus:ring-offset-0"
              />
              <div className="flex items-center gap-2 flex-1">
                <div className={`w-3 h-3 rounded-full ${type.color}`}></div>
                <span className="text-sm font-body text-foreground group-hover:text-primary transition-colors duration-200">
                  {type.label}
                </span>
              </div>
            </label>
          ))}
        </div>
      </div>

      {/* Regions */}
      <div>
        <h4 className="text-sm font-cta font-bold text-foreground mb-3">Region</h4>
        <div className="space-y-2">
          {regions.map((region) => (
            <label
              key={region}
              className="flex items-center gap-3 cursor-pointer group"
            >
              <input
                type="checkbox"
                checked={selectedRegions.includes(region)}
                onChange={() => onRegionToggle(region)}
                className="w-4 h-4 rounded border-border text-primary focus:ring-primary focus:ring-offset-0"
              />
              <span className="text-sm font-body text-foreground group-hover:text-primary transition-colors duration-200">
                {region}
              </span>
            </label>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FilterPanel;